
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import { kwidStore } from '../../../utils/store-accessor';
@Component({
  components: {},
})
export default class Upload extends Vue {
  public isLoading = false;
  public selectedFile = null;

  public srcMobile = 'https://mail.knnidiomas.com.br/knn-master/PromocaoKwidMobile.png';
  public srcDesktop = 'https://mail.knnidiomas.com.br/knn-master/PromocaoKwid.png';

  get getImage() {
    if (this.$vuetify.breakpoint.mobile) {
      return this.srcMobile;
    } else {
      return this.srcDesktop;
    }
  }

  public async handleUploadFile() {
    this.$swal({
      title: 'Confirma o envio do arquivo?',
      text: 'Atualização dos dados da Promoção KNN - KWID',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        let response = await kwidStore.uploadFilesKwid(formData);
        if (response) {
          this.$swal.fire('Dados atualizados com sucesso!', '', 'success');
        } else {
          this.$swal.fire(
            'Erro na atualização dos dados!',
            'Tente novamente ou entre em contato com o setor de desenvolvimento',
            'error'
          );
        }

        this.isLoading = false;
      }
    });
  }

  get validForms() {
    return this.selectedFile != null && this.selectedFile.name.endsWith('.csv');
  }

  public mounted() {}
}
